import gButton from "@/components/g-button/g-button.vue"
import gCard from "@/components/g-card/g-card.vue"
import gDateInput from "@/components/g-date-input/g-date-input";
import gDataTable from "@/components/g-data-table/g-data-table";
import gForm from "@/components/g-form/g-form.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import ProdutoController from "@/shared/controllers/produto/produtoController";
// import OrcamentoProdutoController from "@/shared/controllers/orcamentoProduto/OrcamentoProdutoController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";
import FiltroConsultarCartaProposta from "@/shared/view-models/Filtros/FiltroConsultarCartaProposta";
import gPdf from "@/components/g-pdf/g-pdf.vue"
import PDFCartaPropostaFinalizado from "@/pages/CartasProposta/GerarCartaProposta/Componentes/PDF/PDFCartaPropostaFinalizado.vue"
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";
import PdfCartaPropstaComComponentes from '@/components/PdfCartaPropstaComComponentes/PdfCartaPropstaComComponentes.vue';
import PdfCartaPropostaSemComponentes from '@/components/PdfCartaPropostaSemComponentes/PdfCartaPropostaSemComponentes.vue';

const name = 'ConsultarCartasProposta'
export default defineComponent({
  name,

  components:{
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-data-table': gDataTable,
    'g-form': gForm,
    'g-steps': gSteps,
    'g-pdf': gPdf,
    PdfCartaPropstaComComponentes,
    PdfCartaPropostaSemComponentes,
    PDFCartaPropostaFinalizado 
  },

  mounted(){
    this.UnidadeArray = this.$store.state.EmpresaArray
    // this.OrcamentoProdutoArray = OrcamentoProdutoController.GetOrcamentoProdutoAtivos().OrcamentoProdutoArray;
    this.StatusArray = CartaPropostaController.GetInformacaoStatusCartaEnum().StatusArray;
    this.atualizaEmpresaRepresentante();

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
    })
  },
  
  data () {
    return {
      renderizaKey:0,
      cartaPropostaTipo:0,
      observacaoBaixa: '',
      MotivoBaixaArray: [],
      ConcorrenteArray: [],
      motivoBaixa: null,
      concorrenteId: null,
      CartasPropostaArray: [],
      ProdutoArray: [],
      CartaPropostaId: null,
      CartaPropostaParaBaixar:null,
      OrcamentoProdutoArray:[],
      ClienteArray: [],
      UnidadeArray: [],
      RepresentanteId: '',
      StatusArray: [],
      objFiltros: new FiltroConsultarCartaProposta(),
      popupDarBaixa:false,
      popupContinuarBaixarCarta: false,
      mostraMensagemVazio: true,
        Colunas: [
          {field: 'codigo', header: 'Nº Carta', width: '50px', ordena: true},
          {field: 'dataInclusaoFormatada', header: 'Dt. Versão 1', width: '100px', ordena: true, ordenacao: 'dataInclusaoFormatada'},
          {field: 'dataAlteracaoFormatada', header: 'Dt. Versão Atual', width: '100px', ordena: true, ordenacao: 'dataAlteracaoFormatada'},
          {field: 'statusEnumCCP', header: 'Status', width: '50px', ordena: true},
          {field: 'nomeRepresentante', header: 'Representante', width: '300px', ordena: true}
        ],

        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'codigo': {value: null, matchMode: this.filtros.CONTAINS},
          'dataInclusaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'dataAlteracaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'statusEnumCCP': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeFantasia': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS}
        },
        popupNovaVersaoCarta: false,
        podeBaixarPdf: false,
        idCartaProposta: null,
        renderiza: false,
        executarvisualizacao: 0,
        nomeCliente: '',
        codigoCarta: '',
        podeGerarPdf: false,
        abrePdf: false,
        inputNomeCliente: ''
    }
  },

  methods: {
    async getTipoCartaPropostaById(cartaPropostaId){
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetTipoCartaPropostaById/${cartaPropostaId}`,
      })
      .then((response) => {
        this.cartaPropostaTipo = response.data.data  
      })
      .catch(() => {
      });
    },


    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++

        this.idCartaProposta = ''
      }, 500);
    },

    async InserirNomeCliente() {
      var nomeCliente = prompt("Digite o nome do cliente:");
      this.inputNomeCliente = nomeCliente
    },

    async abrirPDF(data) {
      await this.InserirNomeCliente()
  
        this.renderiza = true
        
        this.idCartaProposta = data.id
        this.codigoCarta = data.codigo    
        await this.getTipoCartaPropostaById(this.idCartaProposta)

        this.abrePdf = true
        this.podeBaixarPdf = false
        this.renderizaKey++
      
    },

    async baixarPDF(data) {         
      
      await this.InserirNomeCliente()
    

      setTimeout(() => {      
     
          this.renderiza = true

          this.idCartaProposta = data.id
          this.codigoCarta = data.codigo
          this.getTipoCartaPropostaById(this.idCartaProposta)

          this.abrePdf = false
          this.podeBaixarPdf = true
          this.renderizaKey++
        
      }, 500);
    },

    NovaVersao(data){
      this.popupNovaVersaoCarta = true 
      this.CartaPropostaNovaVersao = data.id
      console.log('dashjasdhkjdsakhjsdajhksda', data)
    },
    CreateCartaPropostaVersion () {
      this.$isLoading(true)

      CartaPropostaController.createNewCartaPropostaVersion(this.CartaPropostaNovaVersao).requisicao
      .then(response => {
        this.CartaPropostaId = response.data.data,
        this.popupNovaVersaoCarta = false
        this.$router.push(`gerar-carta-proposta/${this.CartaPropostaId}/orcamento`)
        this.$isLoading(false)
      })
      .catch(() => this.$isLoading(false))
    },

    setMotivoBaixarOrcamento () {
      if(this.motivoBaixa != null) {
        this.$isLoading(true)
        let popup = {
          CartaPropostaId:  this.CartaPropostaParaBaixar,
          motivoBaixa: this.motivoBaixa,
          concorrenteId: this.concorrenteId,
          observacaoBaixa: this.observacaoBaixa
        }
        CartaPropostaController.setMotivoBaixarOrcamento(popup).requisicao
        .then(
        )
        .catch((Error) => {
          console.error(Error);
        })
        .finally(() =>
        this.$isLoading(false),
        this.FecharPopupMotivoBaixarCarta()
        )
      }
      else {
        this.$toast.add({
          severity:'error', 
          summary: 'ERRO', 
          detail:"É necessário selecionar um motivo.", 
          life: 5000
        })
      }  
    },

    getEnumsPopup () {
      CartaPropostaController.GetEnumMotivoBaixa().requisicao
        .then((Response) => {
        this.MotivoBaixaArray = Response.data;
      })
      .catch((Error) => {
        console.error(Error);
      });
      CartaPropostaController.GetConcorrentes().requisicao
        .then((Response) => {
        this.ConcorrenteArray = Response.data.data;
      })
      .catch((Error) => {
        console.error(Error);
      });
    },

    atualizaEmpresaRepresentante(){
      // this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    // CartasPropostaAtivas() {
    //   this.axios({
    //     method: 'Get',
    //     url: process.env.VUE_APP_WEB_API +  `CartaProposta/GetCartasPropostaAtivas/Get`,
    //   })
    //   .then((response) => {
    //     this.CartasPropostaArray = response.data.data
    //   })
    //   .catch(() => {
    //   })
    // },

    Grid () {
      this.mostraMensagemVazio = false
      this.GetCartaPropostaByFiltro()
    },

    GetCartaPropostaByFiltro(){
      this.$isLoading(true)
      CartaPropostaController.GetCartaPropostaByFiltro(this.objFiltros).requisicao
      .then(response => {
        this.CartasPropostaArray = response.data.data;

        this.$isLoading(false)
      })
      .catch(() => this.$isLoading(false))
    },

    baixarCartaProposta(data){
        this.popupDarBaixa = true
        this.CartaPropostaParaBaixar = data.id
    },

    FecharPopupBaixarCarta(){
      this.popupDarBaixa = false
    },

    FecharPopupMotivoBaixarCarta(){
      this.observacaoBaixa = ''
      this.motivoBaixa = null
      this.concorrenteId = ''
      this.popupContinuarBaixarCarta = false
      this.GetCartaPropostaByFiltro()
    },

    ContinuarBaixaCarta(){
      this.getEnumsPopup()
      this.popupDarBaixa = false
      this.popupContinuarBaixarCarta = true
    },

    limpar(){
      this.objFiltros = new FiltroConsultarCartaProposta();
        this.atualizaEmpresaRepresentante()
    },

    RotaCartaPropDet(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `carta-proposta-detalhes/${data.id}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank')
    },
    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.getClienteDropDownsByNome(event, this.objFiltros.UnidadeId, this.objFiltros.RepresentanteId).ClientesArray;
      }, 1000);
    },

    buscarProdutos(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoArray = ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(event, this.objFiltros.RepresentanteId, this.objFiltros.UnidadeId ).ProdutoArray;
      }, 1000);
    },
    
    buscarProdutoNovo(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoNovoByPesquisa(pesquisa, this.objFiltros.UnidadeId).requisicao
        .then((res) => {
          this.OrcamentoProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },
  },
  watch: { 
    

  },
})
